import { useRequest } from 'alova/client'
import { useTranslation } from 'react-i18next'
import { api } from '@/api'

export function useNormOptions() {
  const { t } = useTranslation()
  const {
    data: { brandNormStatus },
  } = useRequest(api.corp.getCorpBrandNormStatus(), { initialData: { brandNormStatus: false } })

  return [
    {
      label: t('dashboard.projectCreatePage.targetMarketNorm'),
      value: 1,
      disabled: false,
    },
    {
      label: t('dashboard.projectCreatePage.brandNorm'),
      value: 2,
      disabled: !brandNormStatus,
    },
  ]
}
